module.exports = __webpack_public_path__ + "static/media/ils-delete.6dfb8cd9.svg";